/**
 * The access token, in memory only. Section 7.2, and item 12 of section 17.
 *
 * Not `localStorage`, not `sessionStorage`, not a cookie the client can read. A
 * module level variable dies with the tab, which is the correct lifetime for a
 * fifteen minute token on a device shared by a whole floor. The refresh token
 * is an HttpOnly cookie the client never sees.
 */
let accessToken: string | null = null;

export function setAccessToken(token: string | null): void {
  accessToken = token;
}

export function getAccessToken(): string | null {
  return accessToken;
}

export function clearAccessToken(): void {
  accessToken = null;
}
